/**
 * Main App with Cold Store + PPC + Soaking Integration
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';

// Cold Store Components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ModuleLauncher from './components/ModuleLauncher';

// PPC Components
import PPCLayout from './components/ppc/PPCLayout';

// Soaking Components
import SoakingDashboard from './components/Soaking/SoakingDashboard';

// Request interceptor - adds JWT token to EVERY axios request
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handles auth errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('🔒 Authentication error - token may be expired');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

console.log('✅ App initialized with Cold Store + PPC + Soaking modules');

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Module Launcher */}
        <Route path="/modules" element={<ModuleLauncher />} />
        
        {/* Cold Store Dashboard */}
        <Route path="/dashboard/*" element={<Dashboard />} />
        
        {/* ✅ PPC Dashboard - All PPC routes */}
        <Route path="/ppc/*" element={<PPCLayout />} />

        {/* ✅ Soaking Module */}
        <Route path="/soaking/*" element={<SoakingDashboard />} />
        
        {/* Default redirects */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
